var Ganiota = function() {

    var clicked_r_id = 'dual_odds_selector';

    var calculateRake = function(odd1, odd2, odd3 = 0) {
        return (1 - (1 / ((odd1 < 1 ? 0 : 1 / odd1) + (odd2 < 1 ? 0 : 1 / odd2) + (odd3 < 1 ? 0 : 1 / odd3)))) * 100;
    };

    var verify_and_compute = function() {
        var odd1 = Generic.parseNumericInput($('#first_odd').val());
        var odd2 = Generic.parseNumericInput($('#second_odd').val());
        var odd3 = Generic.parseNumericInput($('#third_odd').val());
        if (odd1 < 1 || odd2 < 1 || !$('#gform')[0].checkValidity() || (clicked_r_id == 'triple_odds_selector' && odd3 < 1)) {
            $('#result').val('');
        } else {
            var rake = calculateRake(odd1, odd2, odd3);
            $('#result').val(rake.toFixed(2) + '%');
        }
        $('#gform').addClass('was-validated');
    };

    return {
        init: function() {
            $('.ii__form_input').val('');
            $('#gform').removeClass('was-validated');
            $('.ii__form_input').on('keyup paste', function(){
                verify_and_compute();
            });
            $('.ii__odds_selector').click(function() {
                var id = $(this).attr('id');
                if (id != undefined) {
                    Ganiota.rclick(id);
                }
            });
        },
        rclick: function(id) {
            var clicked_r = $('#' + id);
            clicked_r_id = clicked_r.prop('id');
            $('input[type="radio"]').not(clicked_r).prop('checked', false);
            $('#gform').removeClass('was-validated');
            $('.ii__form_input').val('');
            $('#result').val('');

            if (clicked_r_id == 'dual_odds_selector') {
                $('#third_odd_container').addClass('invisible');
                $('#third_odd').prop('disabled', true);
            } else if (clicked_r_id == 'triple_odds_selector') {
                $('#third_odd_container').removeClass('invisible');
                $('#third_odd').prop('disabled', false);
            }
        }
    };
}();

if (typeof exports !== 'undefined') {
    exports.Ganiota = Ganiota;
}
